import { ar } from "vuetify/lib/locale";

export default {
  $vuetify: { ...ar },
  psw: "كلمة المرور",
  topFive: "أعلى خمسة",
  confPsw: "تأكيد كلمة المرور",
  newPsw: "كلمة المرور الجديدة",
  email: "بريد إلكتروني",
  emailId: "عنوان الايميل",
  submit: "يُقدِّم",
  cancel: "يلغي",
  faqs: "التعليمات",
  id: "الهوية",
  processor: "المعالج",
  cuppingScore: "درجة التذوق",
  label: "التسمية",
  expiry: "انتهاء الصلاحية",
  users: "المستخدمين",
  language: "لغة",
  appUser: "مستخدم التطبيق",
  app_users: "مستخدمي التطبيق",
  offline_users: "المستخدمون غير المتصلين",
  dimitraAdmin: "المشرف ديميترا",
  admin_users: "المستخدمين الإداريين",
  search: "يبحث",
  searchBy: "نوع البحث}",
  firstName: "الاسم الأول",
  lastName: "اسم العائلة",
  mobile: "متحرك",
  mobileNumber: "رقم الهاتف المحمول",
  department: "قسم",
  role: "دور",
  status: "حالة",
  permission: "الأذونات",
  activity_log: "سجل النشاطات",
  profile_auth: "مصادقة الملف الشخصي",
  countryCode: "الرقم الدولي",
  selectDept: "اختر القسم",
  selectRole: "حدد الدور",
  edit: "يحرر",
  update: "تحديث",
  delete: "يمسح",
  view: "منظر",
  add: "إضافة",
  deactivate: "إلغاء التنشيط",
  activate: "تفعيل",
  warehouse: "مستودع",
  serverError: "هناك خطأ ما. ",
  minute: "دقيقة",
  perHour: "في الساعة",
  day: "يوم",
  enterDescription: "أدخل الوصف الخاص بك هنا",
  enterHere: "أدخل هنا",
  enterMobile: "أدخل رقم الجوال",
  phoneRequired: "الهاتف مطلوب",
  phoneValid: "يجب أن يكون الهاتف صالحا",
  unableToUpdate: "غير قادر على التحديث",
  membershipPlans: "خطط العضوية",
  byWeek: "حسب الأسبوع",
  byMonth: "شهريا",
  byYear: "سنويا",
  custom: "مخصص",
  name: "اسم",
  regionState: "المنطقة/الولاية",
  provinceState: "المقاطعة/الولاية",
  cityTown: "القرية/المدينة/البلدة",
  membershipValidity: "صلاحية العضوية الأساسية",
  extendedValidity: "صلاحية ممتدة",
  exportAsCSV: "تصدير كملف CSV",
  filterBy: "مصنف بواسطة",
  autoCondition: "شروط السيارات",
  conditional: "الشرط",
  comingSoon: "قريباً",
  userRole: "دور المستخدم",
  additionalInformationRequired: "معلومات إضافية مطلوبة",
  back: "خلف",
  browse: "تصفح",
  clearAll: "امسح الكل",
  continue: "يكمل",
  description: "وصف",
  selectWeek: "حدد الأسبوع",
  confirm: "يتأكد",
  selectMonth: "اختر الشهر",
  selectDateRange: "حدد النطاق الزمني",
  regionDistrict: "المنطقة / المنطقة",
  address: "عنوان",
  familyTribe: "قبيلة العائلة",
  website: "موقع إلكتروني",
  deactivated: "معطل",
  active: "نشيط",
  country: "دولة",
  farmer: "مزارع",
  commodity: "سلعة",
  quantity: "كمية",
  unit: "وحدة",
  price: "سعر",
  save: "يحفظ",
  stateIsReq: "الدولة مطلوبة",
  cityIsReq: "المدينة مطلوبة",
  addressIsReq: "العنوان مطلوب",
  membershipTypeReq: "نوع العضوية مطلوب",
  extendedReasonReq: "مطلوب تمديد السبب",
  numberOfDaysReq: "عدد الأيام مطلوب",
  extendedMembershipValidity: "تمديد صلاحية العضوية",
  set: "تعيين",
  adminRole: "دور المشرف",
  typeMsg: "اكتب رسالتك هنا",
  manageFarmer: "إدارة المزارع",
  manageOfflineFarmers: "إدارة المزارعين غير متصل",
  dashboardSettings: "إعداد لوحة القيادة",
  done: "منتهي",
  noRecordFound: "لا يوجد سجلات",
  farmerName: "اسم المزارع",
  production: "إنتاج",
  registered: "مسجل",
  downloadForReport: "قم بتنزيل التقرير بصيغة PDF",
  downloadPdfReport: "تنزيل التقرير بصيغة PDF",
  notifications: "إشعارات",
  markAllAsRead: "اشر عليها بانها قرات",
  viewNotifications: "عرض الاشعارات",
  youAreUpToDate: "كنت حتى الآن",
  sendNotifications: "الإخطارات المرسلة",
  createNotification: "إنشاء إشعار",
  viewAllNotifications: "عرض جميع الإخطارات",
  note: "*ملاحظة: يتم دعم ملف Mp4 فقط للفيديو",
  validMemberships: "العضويات الصالحة",
  memberShipPlanMessage: "هل أنت متأكد أنك تريد حذف خطة العضوية هذه؟",
  deleteMemberShipPlan: "حذف خطة العضوية",
  systemAutoLogout: "سيقوم النظام بتسجيل الخروج تلقائيًا خلال دقيقتين",
  monday: "الاثنين",
  tuesday: "يوم الثلاثاء",
  Wednesday: "الأربعاء",
  thursday: "يوم الخميس",
  friday: "جمعة",
  saturday: "السبت",
  sunday: "الأحد",
  warning: "تحذير",
  addnewOfflineFarmer: "أضف مزارعًا جديدًا غير متصل بالإنترنت",
  export: "يصدّر",
  createNewOfflineFarmer: "إنشاء مزارع جديد غير متصل",
  offlineFarmerForByingStationOnly: "مزارع غير متصل لشراء المحطة فقط (محلي)",
  offlineFarmerForAllByingStations:
    "مزارع غير متصل لجميع محطات الشراء (العالمية)",
  noDataAvailable: "لا تتوافر بيانات",
  buyingStation: "محطة الشراء",
  dryMillingStation: "محطة التصنيع الجاف",
  mergeWithExistingAccount: "دمج مع حساب موجود",
  createNewAccount: "انشاء حساب جديد",
  mobileOrEmailRequiredForRegister:
    "لتسجيل التطبيق، يجب تقديم تفاصيل واحدة على الأقل إما رقم الهاتف المحمول أو البريد الإلكتروني.",
  selectLanguage: "اختار اللغة",
  basicPlan: "الخطة الأساسية",
  local: "محلي",
  newUser: "مستخدم جديد",
  merged: "تم الدمج",
  global: "عالمي",
  qrcode: "رمز الاستجابة السريعة",
  sloganIsRequired: "الشعار مطلوب",
  titleIsrequired: "العنوان مطلوب",
  descriptionisRequired: "الوصف مطلوب",
  websiteLinkNameIsRequired: "اسم الرابط الموقع الإلكتروني مطلوب",
  mapLinkIsRequired: "الرابط الخريطة مطلوب",
  thisFieldIsRequired: "هذا الحقل مطلوب",
  selectTopicIsRequired: "اختيار الموضوع مطلوب",
  roleNameLessThan15Character: "يجب أن يكون اسم الدور أقل من 15 حرفًا",
  rejectionMessageIsRequired: "Rejection message is required",
  statusFieldIsRequired: "الحقل الحالة مطلوب",
  byProduction: "حسب الإنتاج",
  byName: "حسب الاسم",
  inactive: "غير نشط",
  subject: "الموضوع",
  deleteTopic: "حذف الموضوع",
  deleteTechnicalIssuesTopic: "هل أنت متأكد أنك تريد حذف موضوع المشاكل الفنية؟",
  activated: "تم التنشيط",
  assigned: "تم التعيين",
  unassigned: "غير معين",

  honey: "عسل",
  naturalDry: "طبيعي (جاف)",
  wine: "نبيذ",
  semiWashed: "نصف مغسول",
  fullWashed: "مغسول بالكامل",
  selectFarmers: "حدد المزارعين",
  errors: {
    cannotBeBlank: "هذا الحقل لا يمكن أن يكون فارغا",
    required: "هذه الخانة مطلوبه",
    somethingWentWrong: "هناك خطأ ما!!!",
  },
  loadingData: "تحميل البيانات...",
  markAsRead: "ضع إشارة مقروء",
  membership: {
    remainingDays: "عدد الأيام الممتدة",
    type: "نوع العضوية",
    validity: "صلاحية العضوية",
    validityLength: {
      custom: "مخصص",
      expired: "منتهي الصلاحية",
      oneTo8Months: "1-8 أشهر",
      lessThan1Month: "أقل من شهر واحد",
      moreThan1Month: "أكثر من 1 سنة",
      sixTo12Months: "6-12 شهرا",
    },
  },
  of: "ل",
  ok: "نعم",
  statusItems: {
    closed: "مغلق",
    open: "يفتح",
  },
  orderByItems: {
    all: "الجميع",
    dateAscending: "التاريخ تصاعدي",
    dateDescending: "التاريخ تنازلي",
    dueDate: "تاريخ الاستحقاق",
    high: "عالي",
    low: "قليل",
    medium: "واسطة",
  },
  orderBy: "ترتيب حسب",
  select: "يختار",
  type: "يكتب",
  uploadImageVideo: "تحميل الصور",
  user: "مستخدم",
  userName: "اسم المستخدم",
  usersSelected: "تم تحديد المستخدمين",
  topics: "المواضيع",
  date: "تاريخ",
  addNew: "اضف جديد",
  exportAsCsv: "تصدير كملف CSV",
  noData: "لاتوجد بيانات",
  login: {
    welcomeMsg: "مرحباً! ",
    info: "أدخل بيانات الاعتماد الخاصة بك.",
    forgot: "هل نسيت كلمة السر؟",
    btn: "تسجيل الدخول",
    unableToLogin: "غير قادر على تسجيل الدخول",
  },
  forgot: {
    info_l1: "الرجاء إدخال عنوان البريد الإلكتروني المرتبط بحسابك. ",
    info_l2: "الرجاء إدخال رقم هاتفك المحمول المرتبط بحسابك. ",
    info_l3:
      "الرجاء اختيار أحد الخيارات التالية لتلقي تعليمات حول كيفية إعادة تعيين كلمة المرور الخاصة بك",
    forgotQ: "نسيت كلمة السر؟",
    loginNow: "تسجيل الدخول الآن",
    resetSucc: "تمت إعادة تعيين كلمة المرور الخاصة بك بنجاح",
    resetSucc_l2:
      "يمكنك الآن استخدام كلمة المرور الجديدة لتسجيل الدخول إلى حسابك.",
    entPsw: "الرجاء إدخال كلمة المرور الجديدة.",
    resetPsw: "اعد ضبط كلمه السر",
    resendOTP: "إعادة إرسال كلمة المرور لمرة واحدة",
    enterCorrectOTP: "الرجاء إدخال كلمة المرور الصحيحة.",
    enterOTP:
      "الرجاء إدخال كلمة مرور لمرة واحدة (OTP) تم استلامها على البريد الإلكتروني/الهاتف المحمول.",
    backToLoginPage: "العودة إلى صفحة تسجيل الدخول",
    recieveCodeFalse: " لم أتلق الرمز",
  },
  dashboard: "لوحة القيادة",
  mainDashboard: "لوحة المعلومات الرئيسية",
  userDashboard: "لوحة المعلومات للمستخدم",
  userslist: {
    createNewUser: "إنشاء مستخدم جديد",
    chooseCreateType: "يرجى اختيار إحدى الخيارات التالية:",
    addNewUser: "إضافة مستخدم جديد",
    editUser: "تحرير المستخدم",
    addNewAdmin: "إضافة مستخدم مسؤول",
    userLoading: "تحميل المستخدمين... يرجى الانتظار",
    noUser: "لا يتوفر مستخدم",
    extendVal: "تمديد الصلاحية",
    extendReason: "سبب التمديد",
    extendReasonMsg: "حدد سبب تمديد العضوية",
    exportAsCSV: "تصدير كملف CSV",
    membershipType: "نوع العضوية",
    membershipValidity: "صلاحية العضوية",
    regionState: "المنطقة/الولاية",
    cityTown: "المدينة/البلدة",
    clearAll: "مسح الكل",
    search: "البحث",
    familyTribe: "أدخل قبيلتك العائلية",
    enterWebsite: "أدخل الموقع",
    registrationDate: "تاريخ التسجيل",
    single: "فردي",
    multiple: "متعدد",
    user: "مستخدم",
  },
  addEdituser: {
    facilityPicture: "صورة المنشأة",
    firstNameRequired: "الإسم الأول مطلوب",
    firstNameOllyAlpha: "يمكن أن يحتوي الاسم الأول على حروف أبجدية فقط",
    firstNameLimit: "يجب أن يكون الاسم الأول أقل من 30 حرفًا",
    lastNameRequired: "إسم العائلة مطلوب",
    lastNameOllyAlpha: "يمكن أن يحتوي الاسم الأخير على حروف أبجدية فقط",
    lastNameLimit: "يجب أن يكون اسم العائلة أقل من 30 حرفًا",
    emailReuired: "البريد الالكتروني مطلوب",
    emailInvalid: "تنسيق البريد الإلكتروني غير صالح.",
    mobileRequired: "رقم الجوال مطلوب",
    invalidMobile: "تنسيق رقم الجوال غير صالح.",
    pswRequired: "كلمة المرور مطلوبة",
    deptRequired: "القسم مطلوب",
    roleRequired: "الدور مطلوب",
    countryRequired: "رمز البلد مطلوب",
    userUpdated: "تم تحديث المستخدم",
    userNotUpdated: "لم يتم تحديث المستخدم",
    activateAct: "تفعيل حساب",
    deactivateAct: "تعطيل الحساب",
    userActivated: "تم تنشيط المستخدم",
    userDeactivated: "تم إلغاء تنشيط المستخدم",
    deactivateUser: "إلغاء تنشيط المستخدم",
    deactivateMsg: "هل أنت متأكد أنك تريد تغيير حالة المستخدم.",
    userAdded: "تمت إضافة المستخدم",
    userNotAdded: "لم تتم إضافة المستخدم",
    editAppUser: "تحرير مستخدم التطبيق",
    validityUpTo: "صلاحية تصل إلى",
  },
  permissions: {
    savePermissions: "حفظ الأذونات",
    moduleName: "اسم وحدة",
    view: "منظر",
    create: "يخلق",
    update: "تحديث",
    delete: "يمسح",
    permissionsUpdated: "تم تحديث الأذونات",
    permissionsNotUpdated: "لم يتم تحديث الأذونات",
    selectMembership: "اختر العضوية",
    noPermMsg:
      'الرجاء تحديد نوع العضوية باستخدام القائمة المنسدلة "نوع العضوية" أعلاه لعرض الأذونات الخاصة بك',
    selectRoleMsg: "الرجاء تحديد الدور أعلاه لإظهار الأذونات",
  },
  logs: {
    time: "وقت",
    username: "اسم المستخدم",
    role: "دور",
    terminalID: "معرف المحطة الطرفية",
    moduleAccessed: "تم الوصول إلى الوحدة النمطية",
    typeOfAccess: "نوع الوصول",
    activityLogDetails: "تفاصيل سجل النشاط",
    userId: "معرف المستخدم",
    lastLogin: "آخر تسجيل دخول",
    geoAccPoint: "نقطة الوصول الجغرافية",
    ipAdd: "عنوان IP",
    filesAccessed: "تم الوصول إلى الملفات",
    funAccessed: "تم الوصول إلى الوظيفة",
    webUrl: "عنوان URL لصفحة الويب",
    unsuccAtmp: "محاولة تسجيل دخول غير ناجحة",
    view: "منظر",
    membershipType: "نوع العضوية",
  },
  profileSetting: {
    profileAuthSettings: "إعدادات مصادقة الملف الشخصي",
    changeSettings: "تغيير الاعدادات",
    loginLogoutSettings: "إعدادات تسجيل الدخول/تسجيل الخروج",
    autoLogout: "تسجيل الخروج التلقائي",
    unsuccAtmp: "محاولات تسجيل الدخول غير الناجحة",
    unsuccLoginLock: "فترة تأمين تسجيل الدخول غير ناجحة",
    pswCrisetup: "إعداد معايير كلمة المرور",
    pswLength: "طول كلمة المرور",
    noOfUniquePsw: "عدد كلمات المرور الفريدة المطلوبة ",
    maxPswAge: "الحد الأقصى لعمر كلمة المرور",
    AccRangeOfchars: "نطاق مقبول من الأحرف",
    upperCase: "الأحرف الكبيرة",
    lowerCase: "أحرف صغيرة",
    numbers: "أعداد",
    specialChars: "شخصيات خاصة",
    settingsUpdated: "تم تحديث الإعدادات",
    settingsNotUpdated: "لم يتم تحديث الإعدادات",
    organization: "منظمة",
    organizationLogo: "شعار المنظمة",
    organizationSplash: "شاشة البداية للمنظمة",
  },
  dashboardSection: {
    greenBeansData: "إدارة الفاصوليا الخضراء",
    dryMilling: "الطحن الجاف",
    modules: "وحدات",
    allowances: "البدلات",
    maxUserAllowed: "الحد الأقصى المسموح به للمستخدمين ",
    satelliteReportsAllowed: "تقارير الأقمار الصناعية مسموح بها ",
    advanceReport: "التقارير المتقدمة مسموح بها ",
    subscriptionUpTo: "الاشتراك يصل إلى",
    roleAllowed: "الأدوار المسموح بها ",
    moduleAllowed: "الوحدات المسموح بها ",
    registeredUsers: "المستخدمون المسجلون",
    validMemberships: "العضويات الصالحة",
    activeUsers: "المستخدمين النشطين",
    deactivatedUsers: "المستخدمون المعطلون",
    membershipValidity: "صلاحية العضوية",
    lessThan1Month: "أقل من شهر واحد",
    months1to6: "1-6 أشهر",
    months6to12: "6-12 شهرًا",
    moreThan1Year: "أكثر من 1 سنة ",
    cropOverview: "نظرة عامة على المحاصيل",
    plantations: "المزارع ",
    coffeeData: "بيانات القهوة",
    availableModules: "الوحدات المتاحة",
    roleList: "مزارع، محطة شراء، مستودع",
    memberData: "بيانات الأعضاء",
    userType: "نوع المستخدم",
    registered: "مسجل",
    offlineUsers: "المستخدمون غير المتصلين",
    lessThanOneMonth: "<1 شهر",
    cacaoData: "بيانات الكاكاو",
    dryCacao: "الكاكاو الجاف",
    traceability: "تتبع",
  },
  adminRoles: {
    adminRoles: "أدوار المشرف",
    roleName: "اسم الدور",
    description: "وصف",
    viewPermissions: "عرض الأذونات",
    createAdminRole: "إنشاء دور المشرف",
    enterDesHere: "أدخل الوصف الخاص بك هنا",
    deleteRole: "حذف الأدوار",
    deleteMsg: "هل أنت متأكد أنك تريد حذف الدور؟",
    roleReq: "اسم الدور مطلوب",
    roleLimit: "يجب أن يكون اسم الدور أقل من 15 حرفًا",
    desReq: "الوصف مطلوب",
    desLimit: "يجب أن يكون الوصف 40 حرفًا أو أقل",
    roleSuccess: "تم إنشاء الدور بنجاح",
    editAdminRole: "تحرير دور المشرف",
    roleUpdated: "تم تحديث الدور",
    noRole: "لم يتم العثور على أدوار المشرف",
    noRoleMsg: 'يرجى إنشاء دور المسؤول باستخدام الزر "إنشاء دور المسؤول" أعلاه',
  },
  membershipplanSection: {
    defaultPlan: " الخطة الافتراضية",
    planType: "نوع الخطة",
    planDuration: "مدة الخطة",
    planFee: "رسوم الخطة",
    satelliteReport: "تقرير الأقمار الصناعية",
    advanceReport: "تقرير مسبق",
    addMembership: "إضافة عضوية",
    addMembershipPlan: "إضافة خطة العضوية",
    editMembershipPlan: "تحرير خطة العضوية",
    accessSetelite: "الوصول إلى تقارير القمر الصناعي (مجموعة من 5 تقارير)",
    accessAdvanceReport: "الوصول إلى التقارير المتقدمة",
    memPlanReq: "خطة العضوية مطلوبة",
    memPlanReqLimit: "يجب أن تكون خطة العضوية أقل من 20 حرفًا",
    SatelliteReq: "مطلوب تقرير القمر الصناعي",
    advancedReportReq: "مطلوب تقرير متقدم",
    durationReq: "مدة العضوية مطلوبة",
    feeReq: "مطلوب رسوم العضوية",
    cantLesThenZero: "لا يمكن أن يكون أقل من 0",
    roleReq: "دور المستخدم مطلوب",
  },
  tickets: {
    actions: {
      create: "إنشاء تذكرة",
      delete: "حذف التذكرة",
      edit: "تحرير التذكرة",
    },
    areaOfRequest: "مجال الطلب",
    assignee: "المكلف",
    deleteTicket: {
      confirmation: "هل أنت متأكد أنك تريد حذف تذكرة واحدة ({0})؟",
    },
    dueDate: "تاريخ الاستحقاق",
    filters: {
      ticketFor: "تذكرة ل",
    },
    form: {
      ticketType: {
        admin: "إنشاء تذكرة لمشرف ديميترا",
        user: "إنشاء تذكرة لمستخدم التطبيق",
      },
    },
    markAsRead: "ضع إشارة مقروء",
    messages: {
      created: {
        success: "تم إنشاء التذكرة بنجاح",
      },
      deleted: {
        success: "تم حذف التذكرة بنجاح",
      },
    },
    noData: "لم يتم العثور على التذاكر!",
    noDataHelpText: "لم يتم تخصيص أي تذاكر لك{0}بعد. ",
    pickerInMenu: "منتقي في القائمة",
    priority: {
      high: "عالي",
      label: "أولوية",
    },
    reply: "رد",
    requestedDateTime: "التاريخ والوقت المطلوبان",
    requestorDetails: "تفاصيل الطالب",
    requestorEmail: "البريد الإلكتروني للطالب",
    subject: "موضوع",
    ticketsForItems: {
      all: "الجميع",
      dimitraAdmin: "المشرف ديميترا",
      multipleUsers: "مستخدمين متعددين",
      singleUser: "مستخدم واحد",
    },
    title: "التذاكر",
  },
  memberDataSection: {
    import: "يستورد",
    buyingStation: "محطة الشراء",
    continue: "يكمل",
    farmerId: "معرف المزارع",
    farmerName: "اسم المزارع",
    farmerAddress: "عنوان المزارع",
    quality: "جودة",
    quantity: "كمية",
    importAll: "استيراد الكل",
    importSelected: "استيراد المحدد",
    fileLoaded: "تم تحميل الملف بنجاح",
    incorrectHeaders: "رؤوس غير صحيحة",
    processingBatch: "دفعة المعالجة",
    purchaseOrder: "أمر شراء",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    purchasingOrder: "طلب شراء",
    totalCoffeeCherry: "إجمالي القهوة الكرز",
    airHumidity: "رطوبة الجو",
    density: "كثافة",
    temperature: "درجة حرارة",
    beanMoistureContent: "محتوى رطوبة الفول",
    processType: "نوع العملية",
    batchRating: "حدد تصنيف الدفعة",
    purchaseDate: "تاريخ الشراء",
    selectFarmer: "حدد المزارع",
    selectFarm: "حدد المزرعة",
    selectPlantation: "حدد المزرعة",
    coffeeVariety: "مجموعة متنوعة من القهوة",
    coffeeSpecies: "أنواع القهوة",
    coffeeCherryQuantity: "كمية كرز القهوة",
    coffeeCherryQuality: "جودة القهوة الكرز",
    coffeeType: "نوع القهوة",
    pricePerKg: "السعر للكيلوغرام الواحد",
    processingDone: "تمت المعالجة",
    processedCoffeeOut: "القهوة المعالجة خارج",
    farmer: "مزارع",
    farm: "مزرعة",
    plantation: "بلانتيشن",
    farmers: "المزارعين",
    farmLimitUsed: "حدود المزرعة المستخدمة",
    phoneNumber: "رقم التليفون",
    farmSize: "حجم المزرعة",
    farmLocation: "المزرعة / الموقع",
    date: "تاريخ",
    status: "حالة",
    noFarmers: "لم يتم العثور على مزارعين",
    approveReject: "موافقة/رفض",
    farms: "مزارع",
    crops: "المحاصيل",
    equipment: "معدات",
    noFarms: "لم يتم العثور على مزارع",
    views: "منظر",
    selectStatus: "حدد الحالة",
    approved: "موافقة",
    rejected: "مرفوض",
    reject: "يرفض",
    approve: "يعتمد",
    cancel: "يلغي",
    pending: "قيد الانتظار",
    all: "الكل",
    add: "يضيف",
    describeYourReason: "صف السبب الخاص بك هنا",
    userInformation: "معلومات المستخدم",
    userFarmRequest: "طلب مزرعة المستخدم",
    userFarmInformation: "معلومات مزرعة (مزارع) المستخدمين",
    activity: "نشاط",
    activityType: "نوع النشاط",
    farmZone: "منطقة المزرعة",
    farmerView: "عرض المزارع",
    cropType: "نوع المحاصيل",
    cropVarity: "تنوع المحاصيل",
    area: "منطقة",
    cost: "يكلف",
    geofence: "السياج الجغرافي",
    map_views: "عرض الخريطة",
    viewAllFarms: "عرض جميع المزارع",
    farmersDetails: "تفاصيل المزارع",
    download: "تحميل",
    pOrder: {
      addNew: "اضف جديد",
      viewAll: "عرض الكل",
      selectDate: "حدد تاريخ",
      makeSelection: "اختر خيارا",
      coffeeType: "اكتب كمية القهوة",
      enterPrice: "أدخل السعر",
      reqPurchaseDate: "تاريخ الشراء مطلوب",
      reqFarmer: "مطلوب فلاح",
      reqCoffeeQnty: "مطلوب كمية من كرز القهوة",
      reqPrice: "السعر للكيلوغرام الواحد مطلوب",
      grandTotal: "المجموع الإجمالي",
      selectDateRange: "حدد النطاق الزمني",
      import: "يستورد",
      purchaseId: "معرف الشراء",
      purchaseDate: "تاريخ الشراء",
      farmerName: "اسم المزارع",
      quality: "جودة",
      quantity: "كمية",
      pricePerKg: "السعر للكيلوغرام الواحد",
      selectBuyingStation: "حدد محطة الشراء",
      searchUser: "بحث المستخدمين",
    },
  },
  roleRequest: {
    roleRequest: "طلب الدور",
    userRole: "دور المستخدم",
    approve: "يعتمد",
    reject: "يرفض",
    username: "اسم المستخدم",
    email: "بريد إلكتروني",
    phone: "هاتف",
    roleAssigned: "الدور المعين",
    roleRequested: "الدور المطلوب",
    requestedDate: "التاريخ المطلوب",
    updateRoleRequest: "تحديث طلب الدور",
    message: "رسالة",
    update: "تحديث",
  },
  faqSection: {
    createFaq: "إنشاء الأسئلة الشائعة",
    createTopic: "إنشاء موضوع",
    selectTopic: "حدد الموضوع",
    faqQuestion: "سؤال شائع",
    faqAnswer: "الإجابة على الأسئلة الشائعة",
    uploadImgVid: "تحميل صورة/فيديو الإعلان",
    disInFaq: "عرض في قسم الأسئلة الشائعة",
    editFaq: "تحرير الأسئلة الشائعة",
    topicName: "اسم الموضوع",
    parentTopic: "موضوع الوالدين",
    editTopic: "تحرير الموضوع",
    createSection: "الرجاء إنشاء القسم أولا",
    createTopicFirst: "الرجاء إنشاء الموضوع أولا",
    questionReq: "الأسئلة الشائعة السؤال مطلوب",
    answerReq: "الأسئلة الشائعة الإجابة مطلوبة",
  },
  reports: {
    male: "ذكر",
    female: "أنثى",
    other: "آخر",
    farmerName: "اسم المزارع",
    farmerProdChart: "مخطط الإنتاج الزراعي",
    production: "إنتاج",
    byProduction: "حسب الإنتاج",
    byName: "بالاسم",
    descending: "تنازلي",
    ascending: "تصاعدي",
    buyingStationProdChart: "شراء مخطط إنتاج محطة",
    buyingStation: "محطة الشراء",
    buyingStationName: "شراء اسم المحطة",
    dryMilling: "الطحن الجاف",
    dryMillingName: "اسم الطحن الجاف",
    dryMillingProdChart: "مخطط إنتاج الطحن الجاف",
    view: "منظر",
    date: "تاريخ",
    reports: "التقارير",
    today: "اليوم",
    week: "أسبوع",
    month: "شهر",
    year: "سنة",
    all: "الجميع",
    selectCrop: "حدد اقتصاص",
    selectRegion: "اختر المنطقة",
    downloadPdfReport: "تنزيل التقرير بصيغة PDF",
    export: "يصدّر",
    search: "يبحث",
    yield: "أَثْمَر",
    pests: {
      pestReport: "تقرير الآفات",
      filterByCrops: "تصفية حسب المحاصيل",
      pestStatistics: "إحصائيات الآفات",
      regions: "المناطق",
      occurrences: "الحوادث",
      pestChart: "مخطط الآفات",
      totalArea: "المساحة الكلية",
      pestName: "اسم الآفة",
      region: "منطقة",
      crop: "المحاصيل",
      listByLand: "قائمة حسب الأرض",
    },
    regions: {
      regionalReport: "التقرير الإقليمي",
      listByFarm: "قائمة حسب المزرعة",
      listByFarmers: "القائمة حسب المزارعين",
      listByYield: "قائمة حسب العائد",
      regionalStatistics: "الإحصائيات الإقليمية",
      countries: "بلدان",
      states: "الولايات/المقاطعات",
      city: "قرية مدينة مدينة",
      farmsIn: "مزارع في",
      regionalChart: "الرسم البياني الإقليمي",
      farms: "مزارع",
      regionName: "اسم المنطقة",
      farmers: "المزارعين",
      yield: "العائد / فدان",
    },
    dashboard: {
      topCharts: "الرسوم البيانية الأعلى",
      regions: "المناطق",
      noOfFarms: "عدد المزارع/المنطقة",
      provinces: "ولايات المقاطعات",
      landArea: "مساحة الأرض",
      avgFarmerLand: "متوسط ",
      viewAll: "عرض الكل",
      crops: "المحاصيل",
      plantedAreaCrop: "المساحة المزروعة/المحصول",
      plantedArea: "المساحة المزروعة",
      avgYieldCrop: "متوسط ",
      averageYield: "متوسط ​​العائد",
      yieldChart: "مخطط العائد",
      selectFarm: "حدد المزرعة",
      soilQuality: "جودة التربة",
      pests: "الآفات",
      occurrences: "الأحداث",
      equipments: "المعدات",
      goalAchievedChart: "جدول الأهداف المحققة",
      soilValues: "قيم التربة",
      soil: "تربة",
      showReport: "عرض التقارير على لوحة التحكم",
      selectAll: "اختر الكل",
    },
  },
  traceability: {
    traceability: "التتبع",
    coffeeTraceabilityMngmnt: "إدارة تتبع القهوة",
    traceabilityPage: "صفحة التتبع",
    labelDesigner: "مصمم العلامات",
    additionalInformation: "معلومات إضافية",
    info1:
      "قدم معلومات حول الشعارات الإضافية لمنتجك. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للقهوة.",
    addSlogan: "إضافة شعار",
    sloganTooltip: "أدخل شعارًا لمنتجك",
    additionalLogos: "شعارات إضافية",
    title: "العنوان",
    description: "الوصف",
    mapLink: "رابط الخريطة",
    websiteLink: "رابط الموقع الإلكتروني",
    addMedia: "إضافة وسائط",
    uploadImageVideo: "تحميل صورة/فيديو",
    origin: "المنشأ",
    info2:
      "قدم معلومات حول بلد المنشأ لمنتجك. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للقهوة.",
    countryImage: "صورة البلد",
    institutionalInfo: "معلومات مؤسسية",
    info3:
      "قدم معلومات عن شركتك/تعاونيتك، واشرح للمستهلكين عن العمل الذي قمت به. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للقهوة.",
    cooperativeLogo: "شعار التعاونية",
    traceabilityIntro: "مقدمة حول التتبع",
    info4:
      "سيتيح هذا القسم للمستهلك الوصول إلى تاريخ إنتاج القهوة بأكمله وتاريخ معالجتها. اشرح أهمية التتبع لشركتك/تعاونيتك وللعالم.",
    addLabel: "إضافة علامة",
    chooseTitle: "اختر العنوان",
    chooseLabelDesign: "اختر قالب تصميم العلامة",
    uploadYourLogo: "تحميل شعارك",
    info5:
      "تعليمات: يجب أن يكون حجم الصورة على الأقل 1000 x 1000 بكسل مربع. يمكنك اختيار صورة PNG شفافة لتتناسب مع ألوان الخلفية.",
    chooseTemplateColors: "اختيار ألوان القالب",
    backgroundColor: "لون الخلفية",
    foregroundColor: "لون الأمامية",
    labelStatus: "حالة العلامة",
    inactive: "غير نشط",
    download: "تحميل",
    enterLabelTitle: "أدخل عنوان العلامة",
  },
  cacaoTraceability: {
    traceability: "التتبع",
    cacaoTraceabilityMngmnt: "إدارة تتبع الكاكاو",
    traceabilityPage: "صفحة التتبع",
    labelDesigner: "مصمم العلامات",
    additionalInformation: "معلومات إضافية",
    info1:
      "قدم معلومات حول الشعارات الإضافية لمنتجك. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للكاكاو.",
    addSlogan: "إضافة شعار",
    additionalLogos: "شعارات إضافية",
    title: "العنوان",
    description: "الوصف",
    mapLink: "رابط الخريطة",
    websiteLink: "رابط الموقع الإلكتروني",
    addMedia: "إضافة وسائط",
    uploadImageVideo: "تحميل صورة/فيديو",
    origin: "المنشأ",
    info2:
      "قدم معلومات حول بلد المنشأ لمنتجك. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للكاكاو.",
    countryImage: "صورة البلد",
    institutionalInfo: "معلومات مؤسسية",
    info3:
      "قدم معلومات عن شركتك/تعاونيتك، واشرح للمستهلكين عن العمل الذي قمت به. ستكون هذه المعلومات متاحة للجمهور على صفحة التتبع للكاكاو.",
    cooperativeLogo: "شعار التعاونية",
    traceabilityIntro: "مقدمة حول التتبع",
    info4:
      "سيتيح هذا القسم للمستهلك الوصول إلى تاريخ إنتاج الكاكاو بأكمله وتاريخ معالجته. اشرح أهمية التتبع لشركتك/تعاونيتك وللعالم.",
    addLabel: "إضافة علامة",
    chooseTitle: "اختر العنوان",
    chooseLabelDesign: "اختر قالب تصميم العلامة",
    uploadYourLogo: "تحميل شعارك",
    info5:
      "تعليمات: يجب أن يكون حجم الصورة على الأقل 1000 x 1000 بكسل مربع. يمكنك اختيار صورة PNG شفافة لتتناسب مع ألوان الخلفية.",
    chooseTemplateColors: "اختيار ألوان القالب",
    backgroundColor: "لون الخلفية",
    foregroundColor: "لون الأمامية",
    labelStatus: "حالة العلامة",
    inactive: "غير نشط",
    download: "تحميل",
    enterLabelTitle: "أدخل عنوان العلامة",
  },
  setting: {
    profileAuthSetting: "إعدادات مصادقة الملف الشخصي",
    logInOutSetting: "إعدادات تسجيل الدخول/الخروج",
    autoLogout: "تسجيل الخروج التلقائي",
    unsuccessfulLoginAttempt: "محاولات تسجيل الدخول غير الناجحة",
    unsuccessfulLoginLockPeriod: "فترة تأمين تسجيل الدخول غير ناجحة",
    passCriteriaSetup: "إعداد معايير كلمة المرور",
    passLength: "طول كلمة المرور",
    noUniquePassRequired: "عدد كلمات المرور الفريدة المطلوبة",
    maxPassAge: "الحد الأقصى لعمر كلمة المرور",
    acceptableRangeOfChars: "نطاق مقبول من الأحرف ",
    upperCase: "الأحرف الكبيرة",
    lowerCase: "أحرف صغيرة",
    numbers: "أعداد",
    specialChars: "شخصيات خاصة",
    uniqueSymbols: "رموز فريدة من نوعها",
    loadingData: "تحميل البيانات...",
    currency: "عملة",
    codeActivationTime: "وقت تفعيل الكود",
    changeGlobalSetting: "تغيير الإعدادات العالمية",
    globalSetting: "الاعدادات العامة",
    generalSetting: "الاعدادات العامة",
    hour: "ساعات",
    days: "أيام",
    minutes: "دقائق",
    perDay: "في اليوم",
    perHour: "في الساعة",
    customised: "حسب الطلب",
  },
  coffeeData: {
    windBreaker: "شجرة قواطع الرياح",
    horticultureInfo: "شجرة البستنة",
    shadeTree: "شجرة الظل",
    coffeeVariety: "مجموعة متنوعة من القهوة",
    coffeeSpecies: "أنواع القهوة",
    updateWindBreaker: "تحديث نوع شجرة سترة الرياح",
    addWindBreaker: "إضافة نوع شجرة سترة الرياح الجديد",
    updateHorticultureInfo: "تحديث نوع شجرة معلومات البستنة",
    addHorticultureInfo: "إضافة نوع شجرة معلومات البستنة الجديد",
    updateShadeTree: "تحديث نوع شجرة الظل",
    addShadeTree: "إضافة نوع جديد من شجرة الظل",
    updateCoffeeVariety: "تحديث نوع شجرة القهوة المتنوعة",
    addCoffeeVariety: "إضافة نوع جديد من شجرة القهوة المتنوعة",
    deleteVarietyTitle: "حذف متنوعة",
    deleteVarietyMessage: "هل أنت متأكد أنك تريد حذف Variety؟",
    updateCoffeeSpecie: "تحديث نوع القهوة",
    deleteSpecieTitle: "حذف النوع",
    deleteSpecieMessage: "هل أنت متأكد أنك تريد حذف Specie؟",
    addCoffeeSpecie: "إضافة تشكيلة قهوة جديدة",
    variety: "متنوع",
    selectVariety: "حدد النوع",
    deleteCoffeeRecord: "هل أنت متأكد أنك تريد حذف السجل؟",
    deleteCoffeeData: "حذف بيانات القهوة",
    topicRequired: "حدد الموضوع مطلوب",
    coffeeAddSuccess: "تمت إضافة نوع القهوة بنجاح.",
    treeTypeSuccess: "تمت إضافة نوع الشجرة بنجاح.",
    treeTypeUpdateSuccess: "تم تحديث نوع الشجرة بنجاح.",
    coffeeVarietySuccess: "تمت إضافة صنف القهوة بنجاح.",
    coffeeSpecieSuccess: "تم تحديث نوع القهوة بنجاح.",
    nameRequired: "مطلوب اسم",
    notFound: "لم يتم العثور على بيانات المسؤول عن القهوة",
  },
  cacaoData: {
    cacao: "كاكاو",
    cacaoOverview: "نظرة عامة على الكاكاو",
    cacaoVariety: "تنوع الكاكاو",
    cacaoSpecies: "نوع الكاكاو",
    deleteCacaoData: "حذف بيانات الكاكاو",
  },
  plantation: {
    farmerName: "اسم المزارع",
    phoneNumber: "رقم التليفون",
    plantationName: "اسم المزرعة",
    farm: "مزرعة",
    location: "موقع",
    updatePlantationStatus: "تحديث حالة المزرعة",
    update: "تحديث",
  },
  activationKey: {
    enterActivationKey: "الرجاء إدخال مفتاح التنشيط لتسجيل مستخدم جديد",
    countryRequired: "الدولة مطلوبة",
    activationKeyRequired: "مطلوب مفتاح التنشيط",
    activationKey: "مفتاح التفعيل",
    activationKeyLimit: "مفتاح التنشيط قصير جدًا",
    membershipRoleFilterDesc: "تصفية خطة العضوية حسب الدور",
    email: "بريد إلكتروني",
    filterBy: "مصنف بواسطة",
    membershipRoleFilter: "تصفية دور العضوية",
    appointSalesManager: "تعيين مدير المبيعات",
    appointManager: "تعيين مدير",
    salesManAppSuccess: "تم تعيين مدير المبيعات بنجاح",
    uploadData: "تحميل البيانات المخصصة CSV",
    uploadUserData: "يرجى تحميل ملف بيانات المستخدم",
    downloadCsv: "قم بتنزيل نموذج ملف .csv لمتابعة البنية",
    downloadSample: "قم بتنزيل ملف العينة",
    dragDrop: "السحب والإفلات أو",
    browse: "تصفح",
    yourFile: "ملفك",
    incorectFileType: "نوع الملف غير صحيح",
    somethingWentWrong: "هناك خطأ ما",
    fileUploadedSuccess: "تم رفع الملف بنجاح",
    countRecords: "عد السجلات",
    sendNow: "ارسل الان",
    fileName: "اسم الملف",
    assignActKey: "تعيين مفاتيح التنشيط",
    actKeyAssSucc: "تم تعيين مفاتيح التنشيط بنجاح",
    viewActKey: "عرض مفاتيح التنشيط",
    actKeyQuota: "حصة مفاتيح التنشيط",
    genActKey: "مفاتيح التنشيط التي تم إنشاؤها",
    remActKey: "مفاتيح التنشيط المتبقية",
    penUsed: "المفاتيح المعلقة والمستعملة",
    activationKeyAss: "تم تعيين مفاتيح التنشيط",
    activationKeyUnass: "لم يتم تعيين مفاتيح التنشيط",
    keysAct: "المفاتيح مفعلة",
    uploadedFiles: "الملفات التي يتم تحميلها",
    generateActKey: "إنشاء مفاتيح التنشيط",
    showData: "إظهار البيانات",
    noDataFound: "لم يتم العثور على تاريخ",
    pleaseGenKey: 'يرجى إنشاء مفاتيح التنشيط باستخدام "إنشاء مفاتيح التنشيط"',
    noActKey: "لم يتم إنشاء مفاتيح التنشيط حتى الآن",
    buttonAbv: "الزر أعلاه",
    numberOfActKey: "عدد مفاتيح التنشيط",
    membershipRole: "دور العضوية",
    membershipPlan: "خطة العضوية",
    comments: "تعليقات",
    genKeys: "توليد المفاتيح",
    keysNum: "رقم المفاتيح",
    phoneNumber: "رقم التليفون",
    keysStatus: "حالة المفاتيح",
    ActivationKeysList: "قائمة مفاتيح التنشيط",
    back: "خلف",
    usingActKeys: 'باستخدام "إنشاء مفتاح التنشيط"',
    pleaseGenActKeyss: "يرجى إنشاء مفاتيح التنشيط",
    clearAllFilters: "مسح كافة عوامل التصفية",
    salesManager: "مدير المبيعات",
    clearAll: "امسح الكل",
    generatedBy: "تم إنشاؤها بواسطة",
    numberOfKeys: "عدد المفاتيح",
    action: "فعل",
    viewAllUplFiles: "عرض جميع الملفات التي تم تحميلها",
    bulkUploadUsers: "تحميل مجمّع للمستخدمين",
    noActivationKeyFound: "لم يتم العثور على مفاتيح التنشيط",
    pleaseCreateAdminRole: "الرجاء إنشاء دور المسؤول باستخدام",
    btnCreateAdmin: 'زر "إنشاء دور المشرف" أعلاه',
    donwloadAsCsv: "قم بالتنزيل كملف CSV",
    donwloadAsPdf: "تحميل بصيغة PDF",
    assignSalesManager: "تعيين مدير المبيعات",
    shareViaEmail: "سهم عبر البريد الإلكتروني",
    sendEmail: "ارسل بريد الكتروني",
    emailSend: "تم إرسال البريد الإلكتروني بنجاح",
    donwload: "تحميل",
    deleteFile: "حذف ملف",
    invalidFileData: "بيانات مفتاح التنشيط الموجودة في الملف غير صالحة",
  },
  surveyBuilder: {
    addNewSurvey: "إضافة استطلاع جديد",
    surveyTitle: "عنوان الاستطلاع",
    surveyName: "اسم الاستطلاع",
    surveyDescription: "وصف المسح",
    describeSurvey: "وصف المسح",
    enableScheduling: "تمكين الجدولة",
    selectedDate: "التاريخ المحدد",
    multiStepSurvey: "مسح متعدد الخطوات",
    multiStepSurveyDetails:
      "بناءً على عدد الأسئلة في الخطوة، سيتم تجميع جميع الأسئلة في الاستطلاع وعرضها في خطوات.",
    multiStep: "متعدد الخطوات",
    noQuestionEachStep: "عدد الأسئلة في كل خطوة",
    surveyStatus: "حالة المسح",
    surveyStatusDetails: "لا يمكن تفعيل الاستطلاع إلا بعد إضافة الأسئلة. ",
    selectUsers: "حدد المستخدمين",
    selectUsersDetails:
      "إذا تم تعطيل تحديد المستخدم، فسيكون الاستطلاع متاحًا لجميع المستخدمين. ",
    linkWithFarms: "الارتباط بالمزارع",
    linkWithFarmsDetails: "إذا تم تمكينه، فسيتم ربط المسح بالمزارع الفردية. ",
    enabled: "ممكّن",
    disabled: "عاجز",
    cancel: "يلغي",
    next: "التالي",
    surveySettings: "إعدادات الاستطلاع",
    selectSurveyUsers: "حدد مستخدمي الاستطلاع",
    selectToProceed: "الرجاء تحديد المستخدم (المستخدمين) للمتابعة",
    searchUsers: "بحث المستخدمين",
    usersSelected: "تم تحديد المستخدمين",
    conditional: "الشرط",
    autoConditional: "السيارات الشرطية",
    userName: "اسم المستخدم",
    email: "بريد إلكتروني",
    membershipType: "نوع العضوية",
    membershipValidity: "صلاحية العضوية",
    membershipRemainingDays: "عدد الأيام المتبقية",
    membershipRole: "دور العضو",
    accountProgress: "تقدم الحساب",
    status: "حالة",
    active: "نشيط",
    deactivated: "معطل",
    continue: "يكمل",
    questions: "أسئلة",
    responses: "استجابات",
    deleteSurvey: "حذف الاستطلاع",
    editSurvey: "تحرير الاستطلاع",
    type: "يكتب",
    compulsory: "إلزامي",
    createSurvey: "إنشاء استطلاع",
    surveyBuilder: "منشئ الاستطلاع",
    surveyList: "لائحة الاستبيان",
    farm: "مزرعة",
    responseDate: "تاريخ الرد",
    viewSurvey: "عرض الاستطلاع",
    question: "سؤال",
    settings: "إعدادات",
    addQuestion: "أضف سؤال",
    surveysSubmitted: "تم إرسال الاستطلاعات",
    surveyDetail: "تفاصيل المسح",
    conditionStatus: "حالة الحالة",
    conditionStatusDesc:
      "سيصبح المستخدمون المطابقون للشروط مؤهلين للاستبيان تلقائيًا. ",

    endSurvey: "إنهاء الاستبيان",
    publishSurvey: "نشر الاستبيان",
    copy: "نسخ",
    view: "عرض",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    chooseDate: "اختر التاريخ",
    select: "اختر",
    addSurveyQuestion: "إضافة سؤال للاستبيان",
    editSurveyQuestion: "تحرير سؤال الاستبيان",
    questionScore: "درجة السؤال",
    mandatory: "إلزامي",
    yes: "نعم",
    no: "لا",
    options: "الخيارات",
    typeHere: "اكتب هنا",
    add: "إضافة",
    optionsHint: "الرجاء الضغط على Enter لإضافة إجابة أو انقر على إضافة",
    surveyProgress: "الاستبيان قيد التقدم",
    allResponses: "ملخص كل الإجابات",
    responseQuestion: "الإجابات حسب السؤال",
    dateSubmitted: "تاريخ التقديم",
    answer: "الإجابات",
    totalScore: "الدرجة الإجمالية",
    score: "الدرجة",
    singleSelection: "اختيار واحد",
    multipleSelection: "اختيارات متعددة",
    if: "إذا",
    then: "ثم",
    noResponse: "لا توجد إجابة",
    noSurveyFound: "لم يتم العثور على استبيانات",
    createNewSurvey: 'يرجى إنشاء استبيان باستخدام زر "إنشاء استبيان" أعلاه',
    cannotPublish: "لا يمكن نشر استبيان معطل!",
    deleteSurveyWarn:
      "هل أنت متأكد من رغبتك في حذف الاستبيان؟ إذا قمت بحذفه، سيتم حذف جميع أسئلة الاستبيان والتقديمات بشكل دائم.",
    noQuestionFound: "لم يتم العثور على أسئلة",
    createQuestion: 'يرجى إضافة سؤال أولاً باستخدام زر "إضافة أسئلة" أعلاه',
    deleteQuestion: "هل أنت متأكد من رغبتك في حذف السؤال؟",
    applyChanges: "كيف ترغب في تطبيق هذه التغييرات؟",
    editFutureSurveys: "تحرير الاستبيانات المستقبلية فقط",
    editLiveSurveyOnly: "تحرير الاستبيان الحالي فقط",
    surveyIsLive:
      "يرجى ملاحظة أن الاستبيان مباشر الآن، وتحرير سؤال في هذا الوقت قد يؤثر على التقديمات السابقة. لتجنب أي مشكلات، يمكنك نسخ الاستبيان لإجراء التغييرات على الأسئلة.",
    clickToCopy: "انقر هنا لإنشاء نسخة من الاستبيان",
    applyChangesNow: "تطبيق التغييرات الآن",
    copySurvey: "نسخ الاستبيان",
    changeCopySurveyName: "يمكنك تغيير اسم النسخة المنسوخة من الاستبيان.",
  },
  dashboardReports: {
    appDataReports: "تقارير بيانات التطبيق",
    reports: "التقارير",
  },
  cropsReport: "تقرير المحاصيل",
  oma: {
    // land suitability
    landSuitibility: "توافق الأرض",
    landSuitibilityReport: "تقرير توافق الأرض",
    generateNewReport: "إنشاء تقرير جديد",
    operatorName: "اسم المشغل",
    issueDate: "تاريخ الإصدار",
    chooseYourLocation: "اختر موقعك",
    getLandEvaluation: "الحصول على تقييم الأرض",
    downloadPdfReport: "تحميل تقرير بصيغة PDF",
    pleaseEnterCoordinateText:
      "يرجى إدخال الإحداثيات (خط الطول وخط العرض) لموقع المزرعة لعرض درجتها.",
    noRecordAvailable: "لا تتوفر سجلات.",
    overallScoreForLand: "الدرجة العامة لتوافق الأرض",
    landEvaluation: "تقييم الأرض",
    unsuitable: "غير مناسب",
    marginally: "إلى حد ما",
    suitable: "مناسب",
    moderately: "بشكل معتدل",
    highly: "بشكل كبير",
    back: "رجوع",
    search: "بحث",
    showResults: "عرض النتائج",

    // weather analysis
    weatherAnalysisReport: "تقارير تحليل الطقس",
    weatherAnalysis: "تحليل الطقس",
    getWeatherAnalysis: "الحصول على تحليل الطقس",
    weatherReport: "تقرير الطقس",
    filterByDate: "تصفية حسب التاريخ",
    insertCoordinateText:
      "أدخل الإحداثيات لموقع المزرعة (أو الشجرة) أعلاه، أو استخدم الخريطة أدناه لتحديد موقع المزرعة (أو الشجرة).",

    addTreeGeolocation: "إضافة موقع جغرافي للشجرة",
    editTreeGeolocation: "تعديل موقع جغرافي للشجرة",
    plantationDate: "تاريخ الغرس",
    notes: "ملاحظات",
    uploadTreeImages: "تحميل صور الشجرة",

    valueAtTheCoordinatesOfInterest: "القيمة في الإحداثيات المهتمة",
    "Slope (%)": "الميل (%)",
    "Soil texture (USDA class)": "نسيج التربة (فئة USDA)",
    "Coarse fragments (vol%)": "شظايا خشنة (نسبة الحجم)",
    Land: "الأرض",
    "Artificial surfaces (type)": "الأسطح الصناعية (النوع)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "القرب من الطرق من النوع 1 و 2 (متر)",
    "Soil Chemical Properties": "خصائص التربة الكيميائية",
    "Soil Physical Properties": "خصائص التربة الفيزيائية",
    "Soil organic carbon (%)": "الكربون العضوي في التربة (%)",
    "Soil pH": "درجة حموضة التربة",
    "Soil salinity (ECe))": "ملوحة التربة (ECe)",
    "Mean annual temperature (°C)": "درجة الحرارة السنوية المتوسطة (°C)",
    Weather: "الطقس",
    "Mean minimum temperature of coldest month (°C)":
      "أدنى درجة حرارة متوسطة لأبرد شهر (°C)",
    "Mean annual precipitation (mm)": "هطول الأمطار السنوي المتوسط (ملم)",
  },
  deforestation: {
    eudrComplianceStatus: "حالة الامتثال لـ EUDR",
    deforestationComplianceReport: "تقارير الامتثال لإزالة الغابات",
    noDeforestationComplianceReport:
      "لم يتم العثور على تقرير امتثال لإزالة الغابات",
    loadingDeforestationComplianceReport:
      "جارٍ تحميل تقرير امتثال إزالة الغابات",
    farmName: "اسم المزرعة",
    farmRegistrationId: "معرف تسجيل المزرعة",
    farmerName: "اسم المزارع",
    farmerRegistrationId: "معرف تسجيل المزارع",
    uniqueFarmerId: "معرف المزارع الفريد",
    uniqueFarmId: "معرف المزرعة الفريد",
    farmLocation: "موقع المزرعة",
    area: "المنطقة",
    farmAddress: "عنوان المزرعة",
    dateOfRequest: "تاريخ الطلب",
    status: "الحالة",
    settings: "الإعدادات",

    farmLatitude: "خط عرض المزرعة",
    farmLongitude: "خط طول المزرعة",
    shareQRCode: "مشاركة رمز الاستجابة السريعة",
    copy: "نسخ",

    allCountries: "جميع الدول",
    allRegions: "جميع المناطق",
    allFarms: "جميع المزارع",
    viewCertificate: "عرض الشهادة",

    assignmentIssued: "تم إصدار التكليف",

    complianceCertification: "شهادة الامتثال",
    noComplianceCertification: "لم يتم العثور على شهادة امتثال",
    loadingComplianceCertification: "جارٍ تحميل شهادة الامتثال",

    eudrForestAssessment: "تقييمات غابات EUDR",
    assessmentReport: "تقرير التقييم",
    downloadPDF: "تنزيل PDF",
    back: "العودة",
    farmDetails: "تفاصيل المزرعة",

    dimitraFarmId: "معرف مزرعة ديميترا",
    dimitraFermerId: "معرف مزارع ديميترا",

    totalGeofenceAreaHA: "إجمالي منطقة السياج الجغرافي (AC)",
    forestLossHA: "فقدان الغابات (AC)",
    forestGainHA: "كسب الغابات (AC)",
    forestUnchangedHA: "الغابة لم تتغير (AC)",
    shareCertificate: "مشاركة الشهادة",
    forestUnchanged: "الغابة لم تتغير",
    forestLoss: "فقدان الغابات",
    forestGain: "كسب الغابات",
    totalGeofenceArea: "إجمالي منطقة السياج الجغرافي",
    print: "طباعة",
    deforestationProbability: "احتمالية إزالة الغابات",
    colorCode: "رمز اللون",
    geofenceArea: "منطقة السياج الجغرافي",
    percentageOfGeofenceArea: "نسبة منطقة السياج الجغرافي",
    view: "عرض",
    customization: "تخصيص",
    recordsPerpage: "سجلات لكل صفحة",
    restoreDefault: "استعادة الافتراضي",
    apply: "تطبيق",
    forestAssessmentHelp:
      "إذا كان لديك أسئلة حول هذا التقرير أو تحتاج إلى مساعدة في فهمه، اتصل بنا من خلال مكتب المساعدة.",
    overallDeforestationProbability: "احتمالية إزالة الغابات بشكل عام",
    zeroOrNegligible: "صفر / ضئيلة",
    high: "عالية",
    allStatus: "جميع الحالات",
    low: "منخفضة",
    veryHigh: "عالية جدًا",
    medium: "متوسطة",
    veryLow: "منخفضة جدًا",
    assessmentIssued: "تم إصدار التقييم",
    certificateIssued: "تم إصدار الشهادة",
    assessmentNo: "رقم التقييم",
    blockchainCertificateDesc:
      "سيكون تجزئة التحقق من الشهادة على البلوكشين متاحًا عند قبول الشهادة",
    blockchainValidation: "التحقق من الشهادة على البلوكشين",
    openBlockchainPage: "افتح صفحة البلوكشين",
    clickLinkDesc: "انقر على الرابط أعلاه للتحقق من الشهادة على البلوكشين",
    tooltip: {
      dimitraFarmId: "معرف فريد مرتبط بمزرعة محددة في نظام ديميترا.",
      farmName: "الاسم المعين للمزرعة.",
      farmRegistrationId: "رقم تسجيل المزرعة.",
      farmLocation: "إحداثيات جغرافية محددة أو موقع المزرعة.",
      dimitraFermerId: "معرف مميز مرتبط بمزارع فردي داخل نظام ديميترا.",
      farmerName: "تحديد الفرد المسؤول عن المزرعة.",
      farmerRegistrationId: "رقم تسجيل المزارع.",
      assessmentNo: "رقم فريد مخصص للتقييم.",
    },
    red: "أحمر",
    Yellow: "أصفر",
    transparent: "شفاف",
    darkRed: "أحمر داكن",
    brightRed: "أحمر فاتح",
    orange: "برتقالي",
    lightBlue: "أزرق فاتح",
    teal: "تيل",
    zeroOrNegligibleProbability: "احتمالية إزالة الغابات صفر / ضئيلة",
    veryLowProbability: "احتمالية إزالة الغابات منخفضة جدًا",
    lowProbability: "احتمالية إزالة الغابات منخفضة",
    mediumProbability: "احتمالية إزالة الغابات متوسطة",
    highProbability: "احتمالية إزالة الغابات عالية",
    veryHighProbability: "احتمالية إزالة الغابات عالية جدًا",
    locationName: "اسم الموقع",
  },
  pleaseAgreeToDeclaration: "يرجى الموافقة على البيان لإتمام العملية.",
  importProductionPlaceTT: "يسمح للمستخدمين باستيراد بيانات مكان الإنتاج باستخدام خيارات تحميل أو تنزيل الملفات.",
  defaultCircularGeofence: "سيتم تعيين سياج جغرافي دائري افتراضي بمساحة 4 هكتارات للمزارع التي لا تحتوي على سياج جغرافي أو معلومات عن حجمها. إذا كان متوسط حجم المزرعة أقل من 4 هكتارات، يرجى تغيير الحجم الافتراضي بالنقر على زر 'تحرير' أدناه.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "وفقًا لـ EUDR، لا تتطلب المزارع التي تقل مساحتها عن 4 هكتارات مضلعًا.",
  uploadOneDeforestationAssessmentForAllFarms: "تحميل تقييم إزالة الغابات لجميع المزارع",
  uploadAssessment: "تحميل التقييم",
  noUploadToBlockchain: "لا يوجد تحميل إلى البلوكشين",
  noDataForBlockchain: "نظرًا لعدم وجود تقارير إزالة الغابات التي تم إنشاؤها للأماكن الإنتاجية، لم يكن هناك بيانات للكتابة إلى البلوكشين. إذا كان هذا غير متوقع، يرجى التأكد من أن التقارير للمزارع قد تم إنشاؤها بشكل صحيح في الخطوات السابقة."
};
